const getters = {
    getServiceRequestQuotationList(state) {
        return state.serviceRequestQuotations;
    },
    getQuotationList(state ) {
        return state.quotationList;
    },
    getQuotationMeta(state) {
        return state.quotationMeta;
    }
}

export default getters